export interface Course {
  id: string;
  badge: string;
  type: string;
  category: string;
  title: string;
  duration: string;
  modules: number;
  image: string;
  isPrototype?: boolean;
  brand?: string;
  description?: string;
}

export interface CourseSection {
  title: string;
  subtitle?: string;
  brand?: string;
  courses: Course[];
}

export const courseSections: CourseSection[] = [
  {
    title: 'Latest Releases',
    courses: [
      {
        id: '1',
        badge: 'Available',
        type: 'Self-paced',
        category: 'Public Policy',
        title: 'Audiovisual in Brazil: Governance and Ecosystem',
        duration: '4h',
        modules: 2,
        image: 'https://public.readdy.ai/ai/img_res/d5c0bad2dcef816e8ba2e55ef3350383.jpg',
      },
      {
        id: '2',
        badge: 'Available',
        type: 'Self-paced',
        category: 'Professional Education',
        title: 'Creative Economy in Professional and Technological Education (EPT)',
        duration: '10h',
        modules: 3,
        image: 'https://readdy.ai/api/search-image?query=Creative%20workspace%20with%20art%20supplies%20and%20digital%20tools%2C%20vibrant%20colors%20and%20innovative%20materials%2C%20modern%20educational%20setting%20with%20creative%20projects%2C%20inspiring%20learning%20environment%20with%20artistic%20elements&width=400&height=300&seq=course2&orientation=landscape',
      },
      {
        id: '3',
        badge: 'Available',
        type: 'Self-paced',
        category: 'Public Policy',
        title: 'GDP of Culture and Creative Industries: a look at economic dynamics',
        duration: '5h',
        modules: 3,
        image: 'https://readdy.ai/api/search-image?query=Professional%20business%20workspace%20with%20charts%20and%20economic%20data%2C%20clean%20modern%20office%20environment%2C%20analytical%20tools%20and%20documents%2C%20sophisticated%20learning%20space%20with%20financial%20graphics%20and%20reports&width=400&height=300&seq=course3&orientation=landscape',
      },
      {
        id: '4',
        badge: 'Available',
        type: 'Self-paced',
        category: 'Public Policy',
        title: 'Use of data and indicators for planning and evaluation of public policies',
        duration: '4h',
        modules: 4,
        image: 'https://readdy.ai/api/search-image?query=Data%20analysis%20workspace%20with%20computer%20screens%20showing%20graphs%20and%20statistics%2C%20modern%20office%20setting%2C%20professional%20environment%20with%20analytical%20tools%2C%20clean%20desk%20with%20technology%20and%20documents&width=400&height=300&seq=course4&orientation=landscape',
      },
    ],
  },
  {
    title: 'To Celebrate One Year of Editora LT',
    courses: [
      {
        id: '5',
        badge: 'Available',
        type: 'Self-paced',
        category: 'Educational Accessibility',
        title: 'Artificial Intelligence for Educators',
        duration: '12h',
        modules: 8,
        image: 'https://readdy.ai/api/search-image?query=Modern%20technology%20classroom%20with%20AI%20and%20robotics%20elements%2C%20futuristic%20educational%20environment%2C%20digital%20learning%20tools%20and%20computers%2C%20innovative%20teaching%20space%20with%20technological%20equipment&width=400&height=300&seq=course5&orientation=landscape',
      },
      {
        id: '6',
        badge: 'Available',
        type: 'Self-paced',
        category: 'Early Childhood Education',
        title: 'Ethnic-racial equity in early childhood education',
        duration: '30h',
        modules: 3,
        image: 'https://readdy.ai/api/search-image?query=Diverse%20children%20learning%20together%20in%20colorful%20classroom%2C%20inclusive%20educational%20environment%2C%20multicultural%20teaching%20materials%20and%20books%2C%20warm%20and%20welcoming%20learning%20space%20with%20educational%20toys&width=400&height=300&seq=course6&orientation=landscape',
      },
      {
        id: '7',
        badge: 'Available',
        type: 'Self-paced',
        category: 'Cultural Management',
        title: 'Experiences in cultural management in São Paulo',
        duration: '4h',
        modules: 4,
        image: 'https://readdy.ai/api/search-image?query=Cultural%20center%20workspace%20with%20art%20exhibitions%20and%20creative%20displays%2C%20modern%20gallery%20environment%2C%20professional%20cultural%20management%20setting%2C%20inspiring%20space%20with%20artistic%20installations&width=400&height=300&seq=course7&orientation=landscape',
      },
      {
        id: '8',
        badge: 'Available',
        type: 'Self-paced',
        category: 'Artificial Intelligence',
        title: 'Pathways to the arts for teachers: Artificial Intelligence',
        duration: '10h',
        modules: 5,
        image: 'https://readdy.ai/api/search-image?query=Art%20studio%20with%20digital%20technology%20and%20traditional%20materials%2C%20creative%20teaching%20environment%2C%20modern%20workspace%20with%20artistic%20tools%20and%20computers%2C%20innovative%20educational%20setting&width=400&height=300&seq=course8&orientation=landscape',
      },
    ],
  },
  {
    title: 'To Unite Education and Art',
    courses: [
      {
        id: '9',
        badge: 'Available',
        type: 'Self-paced',
        category: 'Visual Arts',
        title: 'Pathways to the arts for teachers: art and science',
        duration: '10h',
        modules: 5,
        image: 'https://readdy.ai/api/search-image?query=Science%20and%20art%20laboratory%20with%20creative%20experiments%2C%20educational%20workspace%20combining%20art%20and%20science%2C%20colorful%20materials%20and%20scientific%20tools%2C%20inspiring%20learning%20environment&width=400&height=300&seq=course9&orientation=landscape',
      },
      {
        id: '10',
        badge: 'Available',
        type: 'Self-paced',
        category: 'Music Education',
        title: 'Music and mathematics: a perfect harmony',
        duration: '4h',
        modules: 5,
        image: 'https://readdy.ai/api/search-image?query=Music%20classroom%20with%20instruments%20and%20mathematical%20diagrams%2C%20educational%20environment%20combining%20music%20and%20math%2C%20modern%20teaching%20space%20with%20musical%20equipment%20and%20learning%20materials&width=400&height=300&seq=course10&orientation=landscape',
      },
      {
        id: '11',
        badge: 'Available',
        type: 'Self-paced',
        category: 'Literature',
        title: 'Pathways to the arts for teachers: literature in school',
        duration: '10h',
        modules: 4,
        image: 'https://readdy.ai/api/search-image?query=Cozy%20library%20with%20books%20and%20reading%20materials%2C%20warm%20educational%20environment%2C%20comfortable%20learning%20space%20with%20literature%20and%20writing%20tools%2C%20inviting%20classroom%20setting&width=400&height=300&seq=course11&orientation=landscape',
      },
      {
        id: '12',
        badge: 'Available',
        type: 'Self-paced',
        category: 'Photography',
        title: 'Pathways to the arts for teachers: photography',
        duration: '10h',
        modules: 5,
        image: 'https://readdy.ai/api/search-image?query=Photography%20studio%20with%20cameras%20and%20lighting%20equipment%2C%20creative%20educational%20workspace%2C%20modern%20teaching%20environment%20with%20photographic%20tools%20and%20displays%2C%20professional%20learning%20space&width=400&height=300&seq=course12&orientation=landscape',
      },
    ],
  },
  {
    title: 'To Support Work with Children',
    courses: [
      {
        id: '13',
        badge: 'Available',
        type: 'Self-paced',
        category: 'Early Childhood Education',
        title: 'Reading for babies',
        duration: '10h',
        modules: 4,
        image: 'https://readdy.ai/api/search-image?query=Gentle%20nursery%20environment%20with%20colorful%20baby%20books%20and%20soft%20toys%2C%20warm%20early%20childhood%20learning%20space%2C%20comfortable%20reading%20area%20with%20educational%20materials%20for%20infants&width=400&height=300&seq=course13&orientation=landscape',
      },
      {
        id: '14',
        badge: 'Available',
        type: 'Self-paced',
        category: 'Early Childhood Education',
        title: 'Socio-emotional strategies for children: introductory course',
        duration: '2h',
        modules: 1,
        image: 'https://readdy.ai/api/search-image?query=Playful%20classroom%20with%20emotional%20learning%20materials%20and%20colorful%20decorations%2C%20nurturing%20educational%20environment%2C%20child-friendly%20space%20with%20developmental%20toys%20and%20activities&width=400&height=300&seq=course14&orientation=landscape',
      },
      {
        id: '15',
        badge: 'Available',
        type: 'Self-paced',
        category: 'Theater',
        title: 'Theater for children',
        duration: '4h',
        modules: 4,
        image: 'https://readdy.ai/api/search-image?query=Children%20theater%20stage%20with%20colorful%20props%20and%20costumes%2C%20creative%20performance%20space%2C%20playful%20educational%20environment%20with%20dramatic%20arts%20materials&width=400&height=300&seq=course15&orientation=landscape',
      },
      {
        id: '16',
        badge: 'Available',
        type: 'Self-paced',
        category: 'Literature',
        title: 'Training as a reading mediator: Children\'s Literature',
        duration: '4h',
        modules: 12,
        image: 'https://readdy.ai/api/search-image?query=Bright%20children%20library%20with%20colorful%20books%20and%20reading%20corner%2C%20inviting%20educational%20space%2C%20comfortable%20learning%20environment%20with%20children%20literature%20and%20storytelling%20materials&width=400&height=300&seq=course16&orientation=landscape',
      },
    ],
  },
  {
    title: 'To Support Work with Youth',
    courses: [
      {
        id: '17',
        badge: 'Available',
        type: 'Self-paced',
        category: 'Professional Education',
        title: 'Professional Learning Program and Technical Schools: conception and implementation',
        duration: '6h',
        modules: 2,
        image: 'https://readdy.ai/api/search-image?query=Modern%20vocational%20training%20workshop%20with%20technical%20equipment%20and%20tools%2C%20professional%20educational%20environment%2C%20practical%20learning%20space%20with%20industrial%20materials%20and%20workstations&width=400&height=300&seq=course17&orientation=landscape',
      },
      {
        id: '18',
        badge: 'Available',
        type: 'Self-paced',
        category: 'Integral Education',
        title: 'Ame Sua Mente at school',
        duration: '11h',
        modules: 7,
        image: 'https://readdy.ai/api/search-image?query=Peaceful%20mindfulness%20classroom%20with%20meditation%20cushions%20and%20calming%20elements%2C%20serene%20educational%20environment%2C%20wellness-focused%20learning%20space%20with%20natural%20light%20and%20plants&width=400&height=300&seq=course18&orientation=landscape',
      },
      {
        id: '19',
        badge: 'Available',
        type: 'Self-paced',
        category: 'Integral Education',
        title: 'STEAM in the final years of Elementary School',
        duration: '30h',
        modules: 5,
        image: 'https://readdy.ai/api/search-image?query=STEAM%20laboratory%20with%20science%20experiments%20and%20technology%20projects%2C%20innovative%20educational%20workspace%2C%20modern%20learning%20environment%20with%20engineering%20materials%20and%20digital%20tools&width=400&height=300&seq=course19&orientation=landscape',
      },
      {
        id: '20',
        badge: 'Available',
        type: 'Self-paced',
        category: 'Youth Protagonism',
        title: 'Cultural projects: how to start?',
        duration: '2h',
        modules: 5,
        image: 'https://readdy.ai/api/search-image?query=Creative%20youth%20workspace%20with%20project%20planning%20materials%20and%20collaborative%20tools%2C%20dynamic%20educational%20environment%2C%20modern%20space%20with%20cultural%20development%20resources&width=400&height=300&seq=course20&orientation=landscape',
      },
    ],
  },
  {
    title: 'Povos do Brasil',
    subtitle: 'Conheça as histórias, saberes e culturas que formam o Brasil',
    brand: 'povos-do-brasil',
    courses: [
      {
        id: 'pb1',
        badge: 'Em breve',
        type: 'Autoformativo',
        category: 'Povos Indígenas',
        title: 'Povos Indígenas do Brasil: Identidade, Território e Direitos',
        duration: '8h',
        modules: 6,
        brand: 'povos-do-brasil',
        isPrototype: true,
        description: 'Conheça a diversidade dos povos indígenas brasileiros, suas formas de organização social, territorialidade e os marcos legais que garantem seus direitos fundamentais.',
        image: 'https://readdy.ai/api/search-image?query=Vibrant Brazilian indigenous cultural scene with colorful traditional crafts feather ornaments body paint ceremonial objects warm terracotta background folk art style rich cultural heritage earthy ochre deep green tones handmade woven baskets&width=400&height=300&seq=pb1&orientation=landscape',
      },
      {
        id: 'pb2',
        badge: 'Em breve',
        type: 'Autoformativo',
        category: 'Comunidades Quilombolas',
        title: 'Quilombos: Memória, Resistência e Identidade',
        duration: '6h',
        modules: 5,
        brand: 'povos-do-brasil',
        isPrototype: true,
        description: 'Explore a rica história dos quilombos brasileiros, desde os tempos coloniais até as comunidades quilombolas contemporâneas e sua luta pelo reconhecimento territorial.',
        image: 'https://readdy.ai/api/search-image?query=Afro-Brazilian cultural celebration colorful fabrics traditional instruments festive community gathering warm terracotta golden ochre tones folk art aesthetic vibrant cultural heritage handcrafted objects textile patterns&width=400&height=300&seq=pb2&orientation=landscape',
      },
      {
        id: 'pb3',
        badge: 'Em breve',
        type: 'Autoformativo',
        category: 'Culturas Populares',
        title: 'Matrizes Africanas no Brasil: Cultura, Religião e Arte',
        duration: '10h',
        modules: 7,
        brand: 'povos-do-brasil',
        isPrototype: true,
        description: 'Descubra como as tradições africanas moldaram a língua, a culinária, a religiosidade, a música e as artes que fazem parte do cotidiano brasileiro.',
        image: 'https://readdy.ai/api/search-image?query=African Brazilian cultural arts colorful ritual objects beaded jewelry musical instruments vibrant orange deep earthy tones folk art illustration traditional Candomble Capoeira cultural elements festive warm colors&width=400&height=300&seq=pb3&orientation=landscape',
      },
      {
        id: 'pb4',
        badge: 'Em breve',
        type: 'Autoformativo',
        category: 'Povos da Floresta',
        title: 'Saberes da Floresta: Conhecimentos Tradicionais e Sustentabilidade',
        duration: '8h',
        modules: 6,
        brand: 'povos-do-brasil',
        isPrototype: true,
        description: 'Aprenda sobre os saberes tradicionais dos povos da Amazônia e do Cerrado, sua relação com o meio ambiente e a importância do conhecimento ancestral para a sustentabilidade.',
        image: 'https://readdy.ai/api/search-image?query=Amazon rainforest traditional knowledge scene medicinal plants handwoven baskets natural dyes river community life rich forest green warm ochre folk art style traditional crafts botanical illustrations nature inspired&width=400&height=300&seq=pb4&orientation=landscape',
      },
      {
        id: 'pb5',
        badge: 'Em breve',
        type: 'Autoformativo',
        category: 'Culturas Populares',
        title: 'Festas e Celebrações: Manifestações da Cultura Popular Brasileira',
        duration: '5h',
        modules: 4,
        brand: 'povos-do-brasil',
        isPrototype: true,
        description: 'Da Festa do Boi ao Carnaval, do Bumba meu boi ao Maracatu — explore as grandes manifestações da cultura popular que revelam a alma do povo brasileiro.',
        image: 'https://readdy.ai/api/search-image?query=Brazilian popular culture festival colorful papier mache figures festive costumes traditional celebrations vibrant terracotta orange golden yellow folk art character illustrations Bumba meu boi Maracatu carnival scene joyful&width=400&height=300&seq=pb5&orientation=landscape',
      },
      {
        id: 'pb6',
        badge: 'Em breve',
        type: 'Autoformativo',
        category: 'Educação Antirracista',
        title: 'Educação Antirracista: Fundamentos e Práticas em Sala de Aula',
        duration: '12h',
        modules: 8,
        brand: 'povos-do-brasil',
        isPrototype: true,
        description: 'Formação para educadores sobre práticas pedagógicas antirracistas, implementação da Lei 10.639/03 e como trabalhar a diversidade étnico-racial no ambiente escolar.',
        image: 'https://readdy.ai/api/search-image?query=Diverse Brazilian classroom colorful cultural books educational materials representing multiple ethnicities warm terracotta earthy tones folk illustration style multicultural learning environment indigenous Afro-Brazilian cultural objects friendly warm atmosphere&width=400&height=300&seq=pb6&orientation=landscape',
      },
    ],
  },
];
